import React from "react";

const CategoryDashboard = ({ title, items, onNavigate }) => {
  return (
    <div className="p-6 bg-gray-100 min-h-screen">
      <h1 className="text-3xl font-bold text-gray-800 mb-8">{title}</h1>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
        {/* Map through the sub-items and create a clickable block for each */}
        {items.map((item) => (
          <div
            key={item.id}
            className="bg-white p-6 rounded-lg shadow-md hover:shadow-xl hover:bg-green-50 transition-all duration-300 cursor-pointer flex flex-col items-center justify-center text-center h-40"
            onClick={() => onNavigate(item.id)}
          >
            <div className="text-5xl text-green-600 mb-3">{item.icon}</div>
            <h2 className="text-lg font-semibold text-gray-700">
              {item.name}
            </h2>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CategoryDashboard;